module.exports = __webpack_public_path__ + "static/media/monitor.e1776e7d.png";